import dayjs, { type Dayjs } from "dayjs";

const API_PERIOD_PATTERN = /^(0[1-9]|1[0-2])\/(\d{4})$/;
const LEGACY_PERIOD_PATTERN = /^(\d{4})-(0[1-9]|1[0-2])$/;

export const formatOrderStagePeriod = (value: unknown): string => {
  if (typeof value !== "string") return "";

  const period = value.trim();
  const apiMatch = API_PERIOD_PATTERN.exec(period);
  if (apiMatch) return `${apiMatch[1]}/${apiMatch[2]}`;

  const legacyMatch = LEGACY_PERIOD_PATTERN.exec(period);
  if (legacyMatch) return `${legacyMatch[2]}/${legacyMatch[1]}`;

  return "";
};

export const parseOrderStagePeriod = (value: unknown): Dayjs | null => {
  const period = formatOrderStagePeriod(value);
  if (!period) return null;

  const [month, year] = period.split("/");
  return dayjs(`${year}-${month}-01`);
};

export const serializeOrderStagePeriod = (value: Dayjs): string =>
  value.format("MM/YYYY");
